import { flow3tazazxj2t7g4 as flow } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Builders.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
import {
  captureStack1fzi4aczwc4hg as captureStack,
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { FlowCollector26clgpmzihvke as FlowCollector } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/FlowCollector.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function transformWhile(_this__u8e3s4, transform) {
  return flow(transformWhile$slambda_0(_this__u8e3s4, transform));
}
var AbortFlowExceptionClass;
function AbortFlowException() {
  if (AbortFlowExceptionClass === VOID) {
    class $ extends CancellationException() {
      static c67(owner) {
        var $this = this.n('Flow was aborted, no more elements needed');
        captureStack($this, $this.b67_1);
        $this.a67_1 = owner;
        return $this;
      }
      d67(owner) {
        if (!(this.a67_1 === owner))
          throw this;
      }
    }
    initMetadataForClass($, 'AbortFlowException');
    AbortFlowExceptionClass = $;
  }
  return AbortFlowExceptionClass;
}
function *_generator_emit__qph46j($this, value, $completion) {
  var tmp = $this.e67_1($this.f67_1, value, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  if (!tmp) {
    throw AbortFlowException().c67($this);
  }
  return Unit_instance;
}
function *_generator_invoke__zhh2q8($this, it, $completion) {
  var tmp = $this.g67_1.b1h(it, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_0($this, $this$flow, $completion) {
  // Inline function 'com.apollographql.apollo.internal.collectWhile' call
  var this_0 = $this.h67_1;
  var collector = new (transformWhile$2$$inlined$collectWhile$1())($this.i67_1, $this$flow);
  try {
    var tmp = transformWhile$slambda$slambda_0(collector);
    var tmp_0 = this_0.b1d(new (sam$kotlinx_coroutines_flow_FlowCollector$0())(tmp), $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
  } catch ($p) {
    if ($p instanceof AbortFlowException()) {
      var e = $p;
      e.d67(collector);
    } else {
      throw $p;
    }
  }
  return Unit_instance;
}
var sam$kotlinx_coroutines_flow_FlowCollector$0Class;
function sam$kotlinx_coroutines_flow_FlowCollector$0() {
  if (sam$kotlinx_coroutines_flow_FlowCollector$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.j67_1 = function_0;
      }
      s1d(value, $completion) {
        return this.j67_1(value, $completion);
      }
      n5() {
        return this.j67_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, FlowCollector()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.n5(), other.n5());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.n5());
      }
    }
    initMetadataForClass($, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector(), FunctionAdapter()], [1]);
    sam$kotlinx_coroutines_flow_FlowCollector$0Class = $;
  }
  return sam$kotlinx_coroutines_flow_FlowCollector$0Class;
}
var transformWhile$2$$inlined$collectWhile$1Class;
function transformWhile$2$$inlined$collectWhile$1() {
  if (transformWhile$2$$inlined$collectWhile$1Class === VOID) {
    class $ {
      constructor($transform, $this_flow) {
        this.e67_1 = $transform;
        this.f67_1 = $this_flow;
      }
      b1h(value, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_emit__qph46j.bind(VOID, this, value), $completion);
      }
      s1d(value, $completion) {
        return this.b1h((value == null ? true : !(value == null)) ? value : THROW_CCE(), $completion);
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, [FlowCollector()], [1]);
    transformWhile$2$$inlined$collectWhile$1Class = $;
  }
  return transformWhile$2$$inlined$collectWhile$1Class;
}
var transformWhile$slambda$slambdaClass;
function transformWhile$slambda$slambda() {
  if (transformWhile$slambda$slambdaClass === VOID) {
    class $ {
      constructor($collector) {
        this.g67_1 = $collector;
      }
      b1i(it, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, it), $completion);
      }
      ud(p1, $completion) {
        return this.b1i((p1 == null ? true : !(p1 == null)) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    transformWhile$slambda$slambdaClass = $;
  }
  return transformWhile$slambda$slambdaClass;
}
function transformWhile$slambda$slambda_0($collector) {
  var i = new (transformWhile$slambda$slambda())($collector);
  var l = (it, $completion) => i.b1i(it, $completion);
  l.$arity = 1;
  return l;
}
var transformWhile$slambdaClass;
function transformWhile$slambda() {
  if (transformWhile$slambdaClass === VOID) {
    class $ {
      constructor($this_transformWhile, $transform) {
        this.h67_1 = $this_transformWhile;
        this.i67_1 = $transform;
      }
      k67($this$flow, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this, $this$flow), $completion);
      }
      ud(p1, $completion) {
        return this.k67((!(p1 == null) ? isInterface(p1, FlowCollector()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    transformWhile$slambdaClass = $;
  }
  return transformWhile$slambdaClass;
}
function transformWhile$slambda_0($this_transformWhile, $transform) {
  var i = new (transformWhile$slambda())($this_transformWhile, $transform);
  var l = ($this$flow, $completion) => i.k67($this$flow, $completion);
  l.$arity = 1;
  return l;
}
//region block: exports
export {
  transformWhile as transformWhile1eyv77fe96rjt,
};
//endregion

//# sourceMappingURL=flows.mjs.map
